import { CALCWEIGHT, CountTicket, GOODSVOLUME, GOODSWEIGHT, PIECE, TICKET } from '@/models/GenerateCondit/Interrelated';

import moment from 'moment';

/**
 * table 数字排序
 * @compare 表字段名
 * @isAbs 是否需要负数转换正数
*/
export const sorteColum = (compare, isAbs, isPercentage) => {
  if (compare) {
    return (a, b) => {
      // 获取并处理百分数
      const parseValue = (value) => {
        if (isPercentage && typeof value === 'string' && value.endsWith('%')) {
          return parseFloat(value.slice(0, -1)) / 100;
        }
        return value;
      };

      const sortA = a[compare] ? (isAbs ? Math.abs(parseValue(a[compare])) : parseValue(a[compare])) : 0;
      const sortB = b[compare] ? (isAbs ? Math.abs(parseValue(b[compare])) : parseValue(b[compare])) : 0;
      return sortA - sortB;
    };
  }
  return false;
};


export const sorteColum2 = (compare, multiple) => {
  if (typeof compare === 'string') {
    return {
      compare: (f, b) => Number.parseInt(f[compare]) || 0 - Number.parseInt(b[compare]) || 0,
      multiple
    }
  }
  return { compare, multiple }
}

/**
 * 通用table表头配置
 * @index 字段索引
 * @isMath 是否需要转正数 false = 否
 * @isSorte 是否需要排序
 * @width antd 设置宽度无法自适应，如果是antd table 单数设置
*/
export const tabeleChildren = (props) => {
  const {
    index = '',
    isMath = true,
    isSorte = true,
    width = 80
  } = props;
  return [
    {
      title: '票数',
      dataIndex: `ticket${index}`,
      align: 'center',
      width: width,
      ellipsis: true,
      render: t => t && (isMath ? Math.abs(t) : t) || 0,
      sorter: isSorte && sorteColum(`ticket${index}`, isMath)
    },
    {
      title: '件数',
      dataIndex: `piece${index}`,
      align: 'center',
      width: width,
      ellipsis: true,
      render: t => t && (isMath ? Math.abs(t) : t) || 0,
      sorter: isSorte && sorteColum(`piece${index}`, isMath)
    },
    {
      title: '重量',
      dataIndex: `goodsWeight${index}`,
      align: 'center',
      width: width,
      render: t => t && ((isMath ? Math.abs(t) : t) / 1000)?.toFixed(2) || 0,
      sorter: isSorte && sorteColum(`goodsWeight${index}`, isMath)
    },
    {
      title: '体积',
      dataIndex: `goodsVolume${index}`,
      align: 'center',
      width: width,
      render: t => t && (isMath ? Math.abs(t) : t).toFixed(2) || 0,
      sorter: isSorte && sorteColum(`goodsVolume${index}`, isMath)
    }
  ]
}

/**
 * 数组分页， 固定每页10条
*/
export const chunkArrayInGroups = (arr) => {
  const size = 10;
  const length = arr.length;
  const newArr = [];
  const i = Math.ceil(length / size);
  let j = 0;
  while (j < i) {
    var spare = length - j * size >= size ? size : length - j * size;
    var temp = arr.slice(j * size, j * size + spare);
    newArr.push(temp);
    j++;
  }
  return newArr;
}

/**
 * 模糊查询数组
 * @type 健
 * @str 模糊值
*/
export const fuzzyQuery = (arr, type, str) => {
  const newArr = [];
  arr.forEach(item => {
    if (item[type].indexOf(str) !== -1) {
      newArr.push(item)
    }
  });
  return newArr;
}


/**
 * 接口公共参数
*/
export const BaseQuery = () => {
  return [CALCWEIGHT, GOODSVOLUME, PIECE, TICKET]
}
export const BaseQuery2 = () => {
  return [CALCWEIGHT, GOODSWEIGHT, GOODSVOLUME, TICKET, PIECE]
}

export const BaseQuery3 = () => {
  return [CALCWEIGHT, GOODSVOLUME, TICKET, PIECE]
}

export const BaseQuery4 = () => {
  return [CALCWEIGHT, GOODSWEIGHT, GOODSVOLUME, CountTicket, PIECE]
}

export const screenTimeQuery = () => {
  return [{
    key: '__time',
    value: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    timeExtractionFn: {
      format: 'EEEE',
      timeZone: 'UTC'
    }
  }]
}

/**
 * 产品类型
*/
export const productItem = ['MINI电商小件', '精准零担', 'MINI电商大件', '定时达', '安心达', '普惠达'];


/**
 * 数组合并值相加
 * type 以什么分组
 * num 相加的参数
*/
export const mergeData = (arr, type, num, other) => {
  arr.forEach(item => {
    item[`${other}s`] = [item[other]]
  })
  const result = arr.reduce((items, item) => {
    let findData = items.find(item2 => item[type] === item2[type]);
    const arr = []
    if (findData) {
      findData[num] += item[num]
      if (other) {
        findData[`${other}s`].push(item[other])
      }
    } else {
      let newItem = {
        [type]: item[type],
        [num]: item[num]
      }
      if (other) {
        newItem = { ...newItem, ...{ [`${other}s`]: item[`${other}s`] } }
      }
      items.push(newItem)
    }
    return items
  }, [])
  return result;
}

/**
 * 数组根据相同值拆分成多个数组
*/
export const recombinationData = (arr, type) => {
  const newArr = [];
  arr.forEach(item => {
    if (newArr.length === 0) {
      newArr.push({
        [type]: item[type],
        child: [item]
      })
    } else {
      let res = newArr.some((item2) => {
        if (item[type] == item2[type]) {
          item2.child.push(item)
          return true
        }
      })
      if (!res) {
        newArr.push({
          [type]: item[type],
          child: [item]
        })
      }
    }
  });
  newArr.sort((a, b) => a[type] - b[type])
  return newArr;
}

/**
 * 车辆固定运力
*/
export const getVolume = {
  '17.5': 28,
  '13.7': 19,
  '13.5': 15,
  '12.5': 17,
  '9.6': 12,
  '8.7': 9,
  '7.7': 8,
  '7.6': 8,
  '7.2': 6.5,
  '6.8': 5,
  '6.5': 5,
  '6.2': 4,
  '5.2': 3.5,
  '4.2': 2,
  '3.5': 1.5,
  '3.3': 1.5,
  '1.5': 1
}

/**
 * 获取两个日期间的所有日期
*/
export function enumerateDaysBetweenDates(startDate, endDate) {
  let daysList = [];
  const start = moment(startDate);
  const end = moment(endDate);
  const day = end.diff(start, "days");
  daysList.push(start.format("YYYY-MM-DD"));
  for (let i = 0; i < day; i++) {
    daysList.push(start.add(1, "days").format("YYYY-MM-DD"));
  }
  return daysList;
}

/** 获取url参数 */
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}


/**
     * 获取某年某月天的天数数组
     * @param 2023-5
     * @returns {arr} [1,2,3...31]
     */
export function getMonthDays(target) {
  const arr = [];
  let year = target.split('-')[0];
  let month = target.split('-')[1];
  let date = new Date(year, month, 0); // 这里的month，比我们日常说的几月份小1，10则表示11月份
  for (let i = 1; i <= date.getDate(); i++) {
    arr.push(i);
  }
  return arr;
}

export const filterData = (pendingFilter,pendingList) => {
  if (pendingFilter === 'locationNotSend') {
    return pendingList.filter(item => !item.leaveTime);
  }
  if (pendingFilter === 'driverNotSend') {
    return pendingList.filter(item => item.leaveTime);
  }
  return pendingList;
};

/**
 * 递归查找路由配置中的component
 * @param routes 路由配置数组
 * @param targetPath 目标路径
 * @returns component路径或null
 */
export function findComponentByPath(routes, targetPath) {
  for (const route of routes) {
    if (route.path === targetPath) {
      return route.component || 'No component defined';
    }
    if (route.routes) {
      const found = findComponentByPath(route.routes, targetPath);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

const ROUTE_TITLE_STYLE =
  'background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; padding: 8px 14px; border-radius: 8px; font-weight: bold; font-size: 14px;';

const buildLabelStyle = (color) => `background: ${color}; color: #fff; padding: 4px 10px; border-radius: 4px; font-weight: 600; font-size: 12px;`;
const buildValueStyle = (color) => `color: ${color}; font-weight: 600; margin-left: 8px; font-size: 12px;`;

const logLine = (label, color, value) => {
  console.log(`%c${label}%c${value ?? '-'}`, buildLabelStyle(color), buildValueStyle(color));
};

const logObjectLine = (label, color, value) => {
  console.log(`%c${label}`, buildLabelStyle(color), value);
};

/**
 * 开发环境下打印路由信息
 * @param pathname 当前路径
 * @param component 组件路径
 * @param options 可选信息，例如 search/hash/state
 */
export function logRouteInfo(pathname, component, options = {}) {
  if (process.env.NODE_ENV !== 'development') return;

  const { search, hash, state } = options;
  const fullUrl = typeof window !== 'undefined' ? window.location?.href : '';
  const componentColor = component ? '#52c41a' : '#ff4d4f';

  console.groupCollapsed('%c🎯 路由信息', ROUTE_TITLE_STYLE);
  logLine('路径', '#1890ff', pathname || '-');
  logLine('组件', componentColor, component || '未找到组件');
  if (search) {
    logLine('查询参数', '#fa8c16', search);
  }
  if (hash) {
    logLine('哈希', '#13c2c2', hash);
  }
  if (fullUrl) {
    logLine('完整地址', '#2f54eb', fullUrl);
  }
  if (state && typeof state === 'object' && Object.keys(state).length) {
    logObjectLine('路由状态', '#722ed1', state);
  }
  console.groupEnd();
}
